export default __webpack_public_path__ + "static/media/SCDream-Black.c8e7afd8.otf";